import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  FEEDBACK_ALL,
  FEEDBACK_CREATE,
  FEEDBACK_EDIT,
  FEEDBACK_FORM,
  FEEDBACK_FORM_ALL,
  FEEDBACK_FORM_CREATE,
  FEEDBACK_FORM_DELETE,
  FEEDBACK_FORM_LIST,
  FEEDBACK_LIST,
  FEEDBACK_TYPES,
  FEEDBACK_UPDATE,
  GLOBAL_STATE,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const FEEDBACK = GLOBAL_STATE

const feedbackSlice = createSlice({
  name: FEEDBACK,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.feedbackAll.pending, state => {
        state[FEEDBACK_ALL].loading = true
      })
      .addCase(actionCreators.feedbackAll.rejected, (state, action) => {
        state[FEEDBACK_ALL].loading = false
        state[FEEDBACK_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackAll.fulfilled, (state, action) => {
        state[FEEDBACK_ALL].loading = false
        state[FEEDBACK_ALL].error = null
        state[FEEDBACK_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackCreate.pending, state => {
        state[FEEDBACK_CREATE].loading = true
      })
      .addCase(actionCreators.feedbackCreate.rejected, (state, action) => {
        state[FEEDBACK_CREATE].loading = false
        state[FEEDBACK_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackCreate.fulfilled, (state, action) => {
        state[FEEDBACK_CREATE].loading = false
        state[FEEDBACK_CREATE].error = null
        state[FEEDBACK_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackEdit.pending, state => {
        state[FEEDBACK_EDIT].loading = true
      })
      .addCase(actionCreators.feedbackEdit.rejected, (state, action) => {
        state[FEEDBACK_EDIT].loading = false
        state[FEEDBACK_EDIT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackEdit.fulfilled, (state, action) => {
        state[FEEDBACK_EDIT].loading = false
        state[FEEDBACK_EDIT].error = null
        state[FEEDBACK_EDIT].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackList.pending, state => {
        state[FEEDBACK_LIST].loading = true
      })
      .addCase(actionCreators.feedbackList.rejected, (state, action) => {
        state[FEEDBACK_LIST].loading = false
        state[FEEDBACK_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackList.fulfilled, (state, action) => {
        state[FEEDBACK_LIST].loading = false
        state[FEEDBACK_LIST].error = null
        state[FEEDBACK_LIST].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackTypes.pending, state => {
        state[FEEDBACK_TYPES].loading = true
      })
      .addCase(actionCreators.feedbackTypes.rejected, (state, action) => {
        state[FEEDBACK_TYPES].loading = false
        state[FEEDBACK_TYPES].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackTypes.fulfilled, (state, action) => {
        state[FEEDBACK_TYPES].loading = false
        state[FEEDBACK_TYPES].error = null
        state[FEEDBACK_TYPES].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackUpdate.pending, state => {
        state[FEEDBACK_UPDATE].loading = true
      })
      .addCase(actionCreators.feedbackUpdate.rejected, (state, action) => {
        state[FEEDBACK_UPDATE].loading = false
        state[FEEDBACK_UPDATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackUpdate.fulfilled, (state, action) => {
        state[FEEDBACK_UPDATE].loading = false
        state[FEEDBACK_UPDATE].error = null
        state[FEEDBACK_UPDATE].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackForm.pending, state => {
        state[FEEDBACK_FORM].loading = true
      })
      .addCase(actionCreators.feedbackForm.rejected, (state, action) => {
        state[FEEDBACK_FORM].loading = false
        state[FEEDBACK_FORM].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackForm.fulfilled, (state, action) => {
        state[FEEDBACK_FORM].loading = false
        state[FEEDBACK_FORM].error = null
        state[FEEDBACK_FORM].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackFormAll.pending, state => {
        state[FEEDBACK_FORM_ALL].loading = true
      })
      .addCase(actionCreators.feedbackFormAll.rejected, (state, action) => {
        state[FEEDBACK_FORM_ALL].loading = false
        state[FEEDBACK_FORM_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackFormAll.fulfilled, (state, action) => {
        state[FEEDBACK_FORM_ALL].loading = false
        state[FEEDBACK_FORM_ALL].error = null
        state[FEEDBACK_FORM_ALL].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackFormCreate.pending, state => {
        state[FEEDBACK_FORM_CREATE].loading = true
      })
      .addCase(actionCreators.feedbackFormCreate.rejected, (state, action) => {
        state[FEEDBACK_FORM_CREATE].loading = false
        state[FEEDBACK_FORM_CREATE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackFormCreate.fulfilled, (state, action) => {
        state[FEEDBACK_FORM_CREATE].loading = false
        state[FEEDBACK_FORM_CREATE].error = null
        state[FEEDBACK_FORM_CREATE].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackFormDelete.pending, state => {
        state[FEEDBACK_FORM_DELETE].loading = true
      })
      .addCase(actionCreators.feedbackFormDelete.rejected, (state, action) => {
        state[FEEDBACK_FORM_DELETE].loading = false
        state[FEEDBACK_FORM_DELETE].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackFormDelete.fulfilled, (state, action) => {
        state[FEEDBACK_FORM_DELETE].loading = false
        state[FEEDBACK_FORM_DELETE].error = null
        state[FEEDBACK_FORM_DELETE].data = action.payload
      })

    builder
      .addCase(actionCreators.feedbackFormList.pending, state => {
        state[FEEDBACK_FORM_LIST].loading = true
      })
      .addCase(actionCreators.feedbackFormList.rejected, (state, action) => {
        state[FEEDBACK_FORM_LIST].loading = false
        state[FEEDBACK_FORM_LIST].error = action.payload as AxiosError
      })
      .addCase(actionCreators.feedbackFormList.fulfilled, (state, action) => {
        state[FEEDBACK_FORM_LIST].loading = false
        state[FEEDBACK_FORM_LIST].error = null
        state[FEEDBACK_FORM_LIST].data = action.payload
      })

    builder.addCase(actionCreators.feedbackAllClear, state => {
      state[FEEDBACK_ALL] = defaultState()
    })

    builder.addCase(actionCreators.feedbackEditClear, state => {
      state[FEEDBACK_EDIT] = defaultState()
    })

    builder.addCase(actionCreators.feedbackFormAllClear, state => {
      state[FEEDBACK_FORM_ALL] = defaultState()
    })

    builder.addCase(actionCreators.feedbackFormClear, state => {
      state[FEEDBACK_FORM] = defaultState()
    })

    builder.addCase(actionCreators.feedbackListClear, state => {
      state[FEEDBACK_LIST] = defaultState()
    })

    builder.addCase(actionCreators.feedbackTypesClear, state => {
      state[FEEDBACK_TYPES] = defaultState()
    })

    builder.addCase(actionCreators.feedbackFormListClear, state => {
      state[FEEDBACK_FORM_LIST] = defaultState()
    })
  },
})

export const { reducer: feedbackReducer } = feedbackSlice
